import { useMemo } from 'react';
import MiscCards from './MiscCards';
import Top5MiscUsers from './Top5MiscUsers';
import ClientMisc from './ClientMisc';
import MiscReasons from './MiscReasons';
// import PerformanceReportsFilter from '../PerformanceTab/PerformanceReportsFilter';
import { useState } from 'react';

const MiscReports = ({ filters }) => {
  //   const [filters, setFilters] = useState({
  //     clientId: '',
  //     scopeId: '',
  //     user: '',
  //     startDate: '',
  //     endDate: '',
  //     // status: '',
  //   });
  //   const handleFilterChange = (updatedFilters) => {
  //   const mappedFilters = {
  //     clientId: updatedFilters.client || '',
  //     scopeId: updatedFilters.scope || '',
  //     employeeId: updatedFilters.user || '',
  //     startDate: updatedFilters.startDate || '',
  //     endDate: updatedFilters.endDate || '',
  //     status: updatedFilters.status || '',
  //   };
  //   setFilters(mappedFilters);
  // };
  const mappedFilters = useMemo(
    () => ({
      clientId: filters.client || '',
      scopeId: filters.scope || '',
      employeeId: filters.user || '',
      startDate: filters.startDate || '',
      endDate: filters.endDate || '',
      monthYear: filters.monthYear || '',
    }),
    [filters]
  );

  return (
    <div className="p-6 bg-gray-100 min-h-screen">
      {/* Page Title */}
      <div className="text-center mb-8">
        <h1 className="text-4xl font-extrabold text-[#1A2B5C] tracking-tight">MISC REPORTS</h1>
        {/* <PerformanceReportsFilter isChecked={false} onFilterChange={handleFilterChange}/> */}
        {/* <div className="mt-2 h-1 w-24 mx-auto rounded-full bg-gradient-to-r from-[#EE1D23] to-[#1A2B5C]" /> */}
      </div>

      {/* Metrics Overview */}
      <MiscCards filters={mappedFilters} />

      {/* Chart Row: Client Sensex and Top Users */}
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 mt-12">
        <ClientMisc filters={mappedFilters} />
        <Top5MiscUsers filters={mappedFilters} />
      </div>

      {/* MISC Reasons Chart */}
      <div className="mt-12">
        <MiscReasons filters={mappedFilters} />
      </div>
    </div>
  );
};

export default MiscReports;
